import { Button, ButtonSize, ButtonType } from '@ardoq/button';
import { colors } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import {
  DropdownMenu2026,
  MenuProps,
  useDropdownTriggerContainer,
} from '@ardoq/dropdown-2026';
import { useId } from 'react';

export type TableDisplaySelectorLabels = {
  buttonLabel: string;
  buttonAriaLabel: string;
};

export const defaultTableDisplaySelectorLabels: TableDisplaySelectorLabels = {
  buttonLabel: 'Display',
  buttonAriaLabel: 'Display settings',
};

export type TableDisplaySelectorViewProps = {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  content: MenuProps;
  labels?: Partial<TableDisplaySelectorLabels>;
};

export const TableDisplaySelectorView = (
  props: TableDisplaySelectorViewProps
) => {
  const popoverId = useId();
  const triggerRef = useDropdownTriggerContainer<HTMLButtonElement>({
    isOpen: props.isOpen,
    openDropdown: () => props.onOpenChange(true),
  });
  const labels = { ...defaultTableDisplaySelectorLabels, ...props.labels };

  return (
    <>
      <Button
        onClick={() => props.onOpenChange(!props.isOpen)}
        buttonType={ButtonType.TERTIARY}
        buttonSize={ButtonSize.SMALL}
        ref={triggerRef}
        aria-label={labels.buttonAriaLabel}
        aria-haspopup="listbox"
        aria-expanded={props.isOpen}
        aria-controls={popoverId}
      >
        <Icon
          iconSize={IconSize.SMALL}
          color={colors.icon}
          iconName={IconName.TUNE_SETTINGS}
        />
        {labels.buttonLabel}
      </Button>
      <DropdownMenu2026
        id={popoverId}
        isOpen={props.isOpen}
        anchorRef={triggerRef}
        onClose={() => props.onOpenChange(false)}
        content={props.content}
        placement={{ side: 'bottom', overflow: 'left' }}
      />
    </>
  );
};
